<script setup>
import StatusIcon from "@/components/citations/partials/ui/StatusIcon.vue";
import {computed} from "vue";

const props = defineProps({
  citation: {
    type: Object,
    required: true,
  }
})

const statuses = computed(() => ({
  name: {
    icon: 'user-profile',
    tooltipText: 'Business Name',
    status: props.citation.name_status,
  },
  phone: {
    icon: 'phone-outline',
    tooltipText: 'Phone Number',
    status: props.citation.phone_status,
  },
  address: {
    icon: 'house-outline',
    tooltipText: 'Address',
    status: props.citation.address_status,
  },
  website: {
    icon: 'navigation-outline',
    tooltipText: 'Website URL',
    status: props.citation.website_status,
  },
  openingHours: {
    icon: 'calendar-outline',
    tooltipText: 'Opening Hours',
    status: props.citation.opening_hours_status,
  },
  photos: {
    icon: 'photo-camera-outline',
    tooltipText: 'Business Photos',
    status: props.citation.photos_status,
  },
}));
</script>

<template>
  <div class="tw-flex tw-gap-2">
    <StatusIcon
      v-for="(status, index) in statuses"
      :key="index"
      :status="status.status"
      :icon="status.icon"
      :tooltipText="status.tooltipText"
    />
  </div>
</template>
